// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"c9482e9c","565":"8b5100f4","720":"d3c63065","740":"2880f7e8","867":"fc21fea6","883":"b48cf452","937":"dd4afeea"}[chunkId] + ".chunk.css";
};